import styled from 'styled-components'
import tokens from '@gympass/yoga-tokens'

import LoadingButton from '@components/LoadingButton'

import { H6 } from '@components/Text'

export const NavigationButtonsWrapper = styled.section`
  padding-bottom: 20px;
`

export const Buttons = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media (min-width: ${tokens.breakpoints.xl.width}px) {
    flex-direction: row-reverse;
  }
`

export const ButtonText = styled(H6)`
  font-weight: 500;
`

export const ContractButton = styled(LoadingButton)`
  margin-top: 16px;

  @media (min-width: ${tokens.breakpoints.md.width}px) {
    margin-top: 72px;
    margin-bottom: 81px;
  }
`

export const RedoSimulation = styled.section`
  margin-bottom: 61px;
  margin-top: 24px;
  width: 100%;

  @media (min-width: ${tokens.breakpoints.md.width}px) {
    margin-top: 72px;
    margin-bottom: 81px;
    margin-right: 24px;
  }
`
